import React, { Component } from 'react'
import Select from 'react-select'
import axios from 'axios'
import swal from 'sweetalert'
import DatePicker from 'react-datetime';
import ls from 'local-storage'
import 'react-datetime/css/react-datetime.css';

export class Details extends Component {
    constructor(props){     
          super(props);   
          this.state = {
            errors: {},
            statelist: [], 
            districtlist: [],
            agencyclasslist: [],
            authoritylist: [],
            details:{},
            agencyid:''
           }  
          this.handleChange = this.handleChange.bind(this);  
          this.statechange = this.statechange.bind(this);  
          this.datepickerhandleChange = this.datepickerhandleChange.bind(this); 
        }   
        componentDidMount() {
            document.title = "Contractor Add/Edit"
            const Axios = axios.create({
              baseURL: process.env.REACT_APP_API_URL,
            });
            const loginToken = ls.get('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;        
            if(this.props.children){
              this.setState({agencyid:this.props.children}); 
              Axios.get(`${process.env.REACT_APP_API_URL}contractor/getcontractor/agencyid/`+this.props.children)
            .then(result=>{
              if(result.status === 200){
                this.setState({details:result.data});  
                if(result.data.state !== ''){
                  const a = {'value':result.data.state};
                  this.statechange(a);
              }                      
              }      
            });      
          }
           
            Axios.get(`${process.env.REACT_APP_API_URL}master/getstate`)
            .then(statelist=>{
                const options = statelist.data.map(d => ({
                    "value" : d.state_code,
                    "label" : d.state_name          
                  }))    
                  this.setState({statelist: options})             
            });   
            Axios.get(`${process.env.REACT_APP_API_URL}master/agencyclass`)        
            .then(result=>{
                const options = result.data.map(d => ({
                    "value" : d.class_code,
                    "label" : d.class_name          
                  }))    
                  this.setState({agencyclasslist: options})             
            });
            Axios.get(`${process.env.REACT_APP_API_URL}master/authority`)
            .then(result=>{
                const options = result.data.map(d => ({
                    "value" : d.regiauthoritycode,
                    "label" : d.regiauthority_name          
                  }))    
                  this.setState({authoritylist: options})             
            }); 
          }
            
          handleValidation(){
            let details = this.state.details;        
            let errors = {};
            let formIsValid = true;
            
            //State Name
            if(!details["statecode"]){
              formIsValid = false;
              errors["statecode"] = "Select State Name";
            }
            
            if(typeof details["statecode"] !== "undefined"){
              if(!details["statecode"].match(/^[A-Z]+$/)){
                formIsValid = false;
                errors["statecode"] = "Only letters";
              }      	
            } 
            //District Name
            if(!details["distcode"]){
                formIsValid = false;
                errors["distcode"] = "Please Select District Name";
              }
    
              if(typeof details["distcode"] !== "undefined" && typeof details["distcode"] !== "number"){          
                  formIsValid = false;
                  errors["distcode"] = "Only Number";      	
              }
            //Agency Name
            if(!details["agencyname"]){
              formIsValid = false;
              errors["agencyname"] = "Please Enter Agency Name";
            }    
            if(typeof details["agencyname"] !== "undefined"){
               if(!details["agencyname"].match(/^[a-zA-Z0-9_ .-]+$/)){
                formIsValid = false;
                errors["agencyname"] = "Please enter alphanumeric characters only";
              }      	
            } 
            // Registering Authority
            if(!details["regiauthority"]){
              formIsValid = false;
              errors["regiauthority"] = "Please Select Registering Authority";
            }    
    
            if(typeof details["regiauthority"] !== "undefined"){
              if(!details["regiauthority"].match(/^[A-Za-z]+$/)){
                formIsValid = false;
                errors["regiauthority"] = "Only Number";
              }      	
            }     
            
            //Registration Class
            if(!details["regclass"]){
              formIsValid = false;
              errors["regclass"] = "Please Select Registration Class";
            }    
            if(typeof details["regclass"] !== "undefined"){
              if(!details["regclass"].match(/^[A-Za-z]+$/)){
                formIsValid = false;
                errors["regclass"] = "Only letters";
              }      	
            } 
    
            //PAN Card
            if(!details["pan"]){
              formIsValid = false;
              errors["pan"] = "Please Enter Pan Card Number";
            }    
            if(typeof details["pan"] !== "undefined"){
              if(!details["pan"].match(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)){
                formIsValid = false;
                errors["pan"] = "Enter valid Pan Number";
              }      	
            }
    
            //GST Number
            if(!details["gst"]){
              formIsValid = false;
              errors["gst"] = "Please Enter GST Number";
            }    
            if(typeof details["gst"] !== "undefined"){
              if(!details["gst"].match(/^(0[0-9]|1[1-9]|2[0-9]|3[0-7])[A-Z]{3}[CPHFATBLJG]{1}[A-Z]{1}\d{4}[A-Z]{1}\d{1}[A-Z0-9]{2}$/g))
              {
                formIsValid = false;
                errors["gst"] = "Enter valid GST Number";
              }      	
            }        
            this.setState({errors: errors});
            return formIsValid;
          }
        
          contactSubmit(e){        
            e.preventDefault();
            if(this.handleValidation()){
              const Axios = axios.create({
                baseURL: process.env.REACT_APP_API_URL,
              });
              const loginToken = ls.get('loginToken');
              Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
              const data =  this.state.details;  
              Axios.post(`${process.env.REACT_APP_API_URL}contractor/insertcontractorbasic`, data) 
                .then((responce) => { 
                  const result = responce.data;
                  if(result.status === 1){
                    swal({
                      title: result.msg,
                      text: "Redirect To Contractor List",
                      icon: "success",
                      buttons: true
                    })
                    .then((responce) => {
                      if (responce) {
                        this.props.history.push({  
                          pathname: '/contractorlist'
                        });                   
                      } else {
                        this.props.history.push({  
                          pathname: '/contractor'
                        }); 
                      }
                    });                
                }
                else{
                  swal("Error", result.msg, "error");               
                }              
                });
            }   
          }       
          async statechange(e){  
            const Axios = axios.create({
              baseURL: process.env.REACT_APP_API_URL,
            });
            const loginToken = ls.get('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;        
            let details = this.state.details;
            let errors = this.state.errors;
            details['state'] = e.value;  
            errors['state'] ='';
            this.setState({details});
            const result = await Axios.post(`${process.env.REACT_APP_API_URL}master/getdistrict`,{'statecode':e.value})
            const options = result.data.map(d => ({
                "value" : d.dcode,
                "label" : d.dname      
              }))    
              this.setState({districtlist: options}) 
          }
          
          async handleChange(event) {
            let details = this.state.details;
            let errors = this.state.errors;
            details[event.target.name] = event.target.value;   
            errors[event.target.name] = '';      
            this.setState({details,errors});       
          } 
         
          async selecthandleChange(name,e) {
            let details = this.state.details;
            let errors = this.state.errors;
            details[name] = e.value;   
            errors[name] = '';       
            this.setState({details,errors});      
          }     
          datepickerhandleChange(name,e){
            let details = this.state.details;
            details[name] = e.format('DD-MM-YYYY');
            this.setState({details});
          }          
    render() {
        return (
            <div className="box-body">
                    <form onSubmit= {this.contactSubmit.bind(this)}>
                        <div className="col-md-12">
                        <div className="col-md-6">
                            <div className="form-group required">
                                <label className="control-label">State</label>
                                <Select 
                                options={this.state.statelist} 
                                name="state" 
                                value={this.state.statelist.filter(({value}) => value === this.state.details.state)  || '' } 
                                onChange={this.statechange} 
                                />                               
                                <span className="text-danger">{this.state.errors["state"]}</span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group required">
                                <label className="control-label">District</label>
                                <Select 
                                options={this.state.districtlist} 
                                name="distcode" 
                                value={this.state.districtlist.filter(({value}) => value === this.state.details.distcode)  || ''} 
                                onChange={this.selecthandleChange.bind(this,'distcode')} 
                                />
                                <span className="text-danger">{this.state.errors["distcode"]}</span>
                            </div>
                        </div>
                        </div>
                        <div className="col-md-12">
                        <div className="col-md-6">
                            <div className="form-group required">
                                <label className="control-label">Agency Name</label>
                                <textarea className="form-control" value={this.state.details.agencyname  || '' } onChange={this.handleChange} name="agencyname" cols="50" rows="2"  />
                                <span className="text-danger">{this.state.errors["agencyname"]}</span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Agency Name Guj</label>
                                <textarea className="form-control" value={this.state.details.agencynameguj  || '' } onChange={this.handleChange} name="agencynameguj" cols="50" rows="2" />								
                            </div>
                        </div>
                        </div>
                        <div className="col-md-12">
                        <div className="col-md-12">
                            <div className="form-group">
                                <h5><input type='checkbox'onChange={this.handleChange} name='isalias' value='Y' /> Is Alias/Partner? એક જ પાન કાર્ડ માં એક કરતા વધુ એજન્સી રજીસ્ટ્રેશન થયેલ હોય તો આ રીતે અહીં નવી એજન્સીનું નામ એડ કરવું</h5>
                            </div>
                        </div>
                        </div>
                        <div className="col-md-12">
                        <div className="col-md-6">
                            <div className="form-group required">
                                <label className="control-label">Registering Authority</label>
                                <Select 
                                options={this.state.authoritylist} 
                                name="regiauthority" 
                                value={this.state.authoritylist.filter(({value}) => value === this.state.details.regiauthority) || ''}  
                                onChange={this.selecthandleChange.bind(this,'regiauthority')} 
                                />
                                <span className="text-danger">{this.state.errors["regiauthority"]}</span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Registration No. </label>
                                <input className="form-control" type="text" value={this.state.details.registration_no || ''} name="registration_no" onChange={this.handleChange} />
                            </div>
                        </div>                        
                        </div>
                        <div className="col-md-12">
                        <div className="col-md-6">
                            <div className="form-group required">
                                <label className="control-label">Registration Class</label>
                                <Select 
                                options={this.state.agencyclasslist} 
                                name="regclass" 
                                value={this.state.agencyclasslist.filter(({value}) => value === this.state.details.regclass) || ''} 
                                onChange={this.selecthandleChange.bind(this,'regclass')}
                                /> 
                                <span className="text-danger">{this.state.errors["regclass"]}</span>                              
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Registered Since</label> 
                                <DatePicker 
                                      timeFormat={false}
                                      onChange={this.datepickerhandleChange.bind(this,'regsince')}
                                      dateFormat="DD-MM-YYYY" 
                                      selected={this.state.details.regsince}
                                      value={this.state.details.regsince || ''}
                                      closeOnSelect 
                                  /> 
                            </div>
                        </div>
                        </div>
                        <div className="col-md-12">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Date of Last Renewal</label>
                                <DatePicker 
                                      timeFormat={false}
                                      onChange={this.datepickerhandleChange.bind(this,'lastrenewdate')}
                                      dateFormat="DD-MM-YYYY" 
                                      selected={this.state.details.lastrenewdate} 
                                      value={this.state.details.lastrenewdate || ''}
                                      closeOnSelect
                                  />
                               </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Valid Up To</label>
                                <DatePicker 
                                      timeFormat={false}
                                      onChange={this.datepickerhandleChange.bind(this,'validupto')}
                                      dateFormat="DD-MM-YYYY" 
                                      selected={this.state.details.validupto}
                                      value={this.state.details.validupto || ''}
                                      closeOnSelect
                                  /> 
                             </div>
                        </div>                        
                        </div>
                        <div className="col-md-12">
                        <div className="col-md-6">
                            <div className="form-group required">
                                <label className="control-label">PAN</label>
                                <input className="form-control text-uppercase" value={this.state.details.pan || ''}  maxLength="10" onChange={this.handleChange} type="text" name="pan" />
                                <span className="text-danger">{this.state.errors["pan"]}</span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>GST No.</label>
                                <input className="form-control text-uppercase" type="text" value={this.state.details.gst || ''} name="gst" maxLength="15" onChange={this.handleChange} />
                                <span className="text-danger">{this.state.errors["gst"]}</span>
                            </div>
                        </div>                        
                        </div>
                        <div className="col-md-12">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Address</label>
                                <input className="form-control" type="text" value={this.state.details.address || ''} name="address" onChange={this.handleChange} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Contact Person</label>
                                <input className="form-control" type="text" value={this.state.details.contact_person || ''} name="contact_person" onChange={this.handleChange} />
                            </div>
                        </div>                        
                        </div>
                        <div className="col-md-12">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Contact Number</label>
                                <input className="form-control" maxLength="10" value={this.state.details.mobile_number || ''} type="text" name="mobile_number" onChange={this.handleChange} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Email</label>
                                <input className="form-control" type="text" value={this.state.details.email || ''} name="email" onChange={this.handleChange} />
                            </div>
                        </div>                        
                        </div>
                        <div className="box-footer">
                        <button type="submit" className="btn btn-primary pull-right" name="Update">Save</button>
                        </div>
                    </form>                
            </div>
        )
    }
}
export default Details